export function SheetErrorMessage({ msg }: { msg: string }) {
  return <span className="color-error">{msg}</span>
}
